import { bodyNavigationInset } from './route-container.css';

// The style file hands out the reference `var(--name)`; a style declaration takes the name.
const INSET = bodyNavigationInset.replace(/^var\((.*)\)$/, '$1');

/** The content of a view's body inside its viewport: what the workspace sidebar stands beside. */
export const workbenchBodyContent = (viewport: HTMLElement) =>
  viewport.querySelector<HTMLElement>(
    ':scope > [data-workbench-body-content="true"]'
  );

/** The room, in px, the content leaves at its left for the workspace sidebar; `null` gives it back. */
export function setWorkbenchBodyNavigationInset(
  content: HTMLElement | null | undefined,
  inset: number | null
) {
  if (inset === null) content?.style.removeProperty(INSET);
  else content?.style.setProperty(INSET, `${inset}px`);
}

/** The room the content leaves right now, as set by the sidebar; empty without any. */
export const workbenchBodyNavigationInset = (content: HTMLElement) =>
  content.style.getPropertyValue(INSET);
